// getShareTemplates.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  SHARE_CONTENT_LIVESTREAM_DETAIL,
  SHARE_CONTENT_STORY,
  SHARE_CONTENT_SHORTS,
} from '../RemoteConfigKeys.js';
import { ShareType } from '../hook/useShortShareLink.js';
import { EMPTY_ARRAY } from '../resource/defaults.js';

/**
 * Select share templates by shareType and karaoke device status
 * @kind selector
 * @param {Immutable.Map} state - root state
 * @param {string} shareType - share type (LIVESTREAM, STORY, SHORT)
 * @param {boolean} isKaraokeDeviceOnline - whether karaoke device is online (only for LIVESTREAM)
 * @return {Array} The selected share templates
 */
const getShareTemplates = createCachedSelector(
  state => getRemoteConfigData(state, SHARE_CONTENT_LIVESTREAM_DETAIL),
  state => getRemoteConfigData(state, SHARE_CONTENT_STORY),
  state => getRemoteConfigData(state, SHARE_CONTENT_SHORTS),
  (_, shareType) => shareType,
  (_, shareType, isKaraokeDeviceOnline) => isKaraokeDeviceOnline,
  (
    livestreamTemplates,
    storyTemplates,
    shortTemplates,
    shareType,
    isKaraokeDeviceOnline = false
  ) => {
    switch (shareType) {
      case ShareType.LIVESTREAM: {
        if (!livestreamTemplates?.length) return EMPTY_ARRAY;

        const [karaokeTemplate, ...commonTemplates] = livestreamTemplates;
        return isKaraokeDeviceOnline
          ? [karaokeTemplate, ...commonTemplates].filter(Boolean)
          : commonTemplates;
      }

      case ShareType.STORY: {
        return storyTemplates || EMPTY_ARRAY;
      }

      case ShareType.SHORT: {
        return shortTemplates || EMPTY_ARRAY;
      }

      default:
        return EMPTY_ARRAY;
    }
  }
)(
  (_, shareType, isKaraokeDeviceOnline) =>
    `shareTemplates_${shareType}_${isKaraokeDeviceOnline}`
);

export default getShareTemplates;
